import VectorAIBase from "./vectorai-base.service";

interface IRetrieveDocuments {
  collection_name: string;
  include_fields: string[];
  page_size: number;
  asc: boolean;
  include_vector: boolean;
  cursor: string;
}

class VectorAIReadService extends VectorAIBase {
  public async retrieveDocuments(query: IRetrieveDocuments) {
    const response = await this.get("/collection/retrieve_documents", query);

    console.log("response", response);
  }
}

export default new VectorAIReadService();
